// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1WK1g","inputWrap":"Table_inputWrap__2uGV7","col":"Table_col__3Y43R","bmiTooltip":"Table_bmiTooltip__2v5Wq"};